import Vue from 'vue'
import VueRouter from 'vue-router'
import testUeditor from '../views/test/test_ueditor.vue'


import { Message } from 'element-ui'


// import AdminLogin from '../views/admin/login.vue'
// import Login from "../views/student/login.vue"


import Login from "../views/newLogin/student.vue"
import AdminLogin from "../views/newLogin/admin.vue"



import AdminIndex from '../views/admin/index.vue'

import AdminQuestionBankIndex from '../views/admin/question_bank/index.vue'
import AdminQuestionBankSubject from '../views/admin/question_bank/subject.vue'
import AdminQuestionBankList from '../views/admin/question_bank/question/list.vue'
import AdminQuestionBankEdit from '../views/admin/question_bank/question/edit.vue'



import AdminExamIndex from '../views/admin/exam/index.vue'
import AdminExamList from '../views/admin/exam/list.vue'
import AdminExamRead from '../views/admin/exam/read.vue'
import AdminExamReadStudent from '../views/admin/exam/read_student.vue'
import AdminExamEdit from '../views/admin/exam/edit.vue'
import AdminExamRowNumber from '../views/admin/exam/row_number.vue'

import AdminPaperIndex from '../views/admin/paper/index.vue'
import AdminPaperList from '../views/admin/paper/list.vue'
import AdminPaperEdit from '../views/admin/paper/edit.vue'

import AdminSystemIndex from '../views/admin/system/index.vue'
import AdminSystemDepartment from '../views/admin/system/deparment/department.vue'
import AdminSystemProfessional from '../views/admin/system/professional/professional.vue'
import AdminSystemPerson from '../views/admin/system/person/person.vue'
import AdminSystemEditPerson from '../views/admin/system/person/edit_person.vue'
import AdminSystemTag from '../views/admin/system/tag/tag.vue'

import AdminWorkLicenseIndex from '../views/admin/work_license/index.vue'
import AdminWorkLicenseList from '../views/admin/work_license/list.vue'
import AdminWorkLicenseEdit from '../views/admin/work_license/edit.vue'
import AdminWorkLicenseManage from '../views/admin/work_license/manage_list.vue'
import AdminWorkLicenseSetting from '../views/admin/work_license/setting.vue'
import AdminWorkLicenseUserList from '../views/admin/work_license/user_work_license_list.vue'
// import AdminWorkLicenseUserManageList from '../views/admin/work_license/user_work_license_manage_list.vue'

import AdminoccupationIndex from '../views/admin/occupation/index.vue'
import AdminoccupationList from '../views/admin/occupation/list.vue'
import AdminoccupationEdit from '../views/admin/occupation/edit.vue'
import AdminoccupationSetting from '../views/admin/occupation/setting.vue'
import AdminoccupationUserList from '../views/admin/occupation/user_occupation_list.vue'


import AdminOverviewkIndex from '../views/admin/overview/index.vue'

import AdminPersonalkIndex from '../views/admin/personal/index.vue'


import Index from "../views/student/index.vue"

import OverviewIndex from "../views/student/overview/index.vue"

import PersonalIndex from "../views/student/personal/index.vue"

import StudentExamIndex from "../views/student/exam/index.vue"
import StudentExamList from "../views/student/exam/list.vue"
import StudentExamPrepare from "../views/student/exam/prepare.vue"
import StudentExamTesting from "../views/student/exam/testing.vue"

import StudentPracticeIndex from "../views/student/practice/index.vue"
import StudentPracticeList from "../views/student/practice/list.vue"
import StudentPracticeExamList from "../views/student/practice/exam_list.vue"
import StudentPracticeExamTesting from "../views/student/practice/imitate_testing.vue"
import StudentPracticeExamPractice from "../views/student/practice/practice.vue"
import StudentPracticeMistakes from "../views/student/practice/mistakes.vue"
import StudentPracticeCollect from "../views/student/practice/collect.vue"

import StudentWorkLicenseIndex from "../views/student/work_license/index.vue"
import StudentWorkLicenseDetails from "../views/student/work_license/details.vue"
import StudentWorkLicenseRecord from "../views/student/work_license/record.vue"

const routes = [{
    path: '/',
    name: '登录',
    component: Login
}, {
    path: '/',
    name: 'Index',
    component: Index, // 学生端首页
    redirect: "/index",
    children: [{
        path: 'index',
        name: 'OverviewIndex', // 首页展示概览
        component: OverviewIndex,
    }, {
        path: 'personal-index',
        name: 'PersonalIndex', // 修改密码
        component: PersonalIndex,
    }, {
        path: 'exam',
        name: 'StudentExamIndex', // 考试中心
        component: StudentExamIndex,
        redirect: "/exam/list",
        children: [{
            path: 'list',
            name: 'StudentExamList', // 我的考试
            component: StudentExamList,
        }, {
            path: 'prepare',
            name: 'StudentExamPrepare', // 考试准备
            component: StudentExamPrepare,
        }, {
            path: 'testing',
            name: 'StudentExamTesting', // 开始考试
            component: StudentExamTesting,
        }, {
            path: 'statistics',
            name: 'StudentExamList', // 数据统计
            component: StudentExamList,
        }]
    }, {
        path: 'practice',
        name: 'StudentPracticeIndex', // 模拟练习
        component: StudentPracticeIndex,
        redirect: "/practice/list",
        children: [{
            path: 'list',
            name: 'StudentPracticeList', // 我的练习
            component: StudentPracticeList,
        }, {
            path: 'mistakes',
            name: 'StudentPracticeMistakes', // 错题集
            component: StudentPracticeMistakes,
        }, {
            path: 'collect',
            name: 'StudentPracticeCollect', // 我的收藏
            component: StudentPracticeCollect,
        }, {
            path: 'exam-list',
            name: 'StudentPracticeExamList', // 模拟考试列表
            component: StudentPracticeExamList,
        }, {
            path: 'exam-testing',
            name: 'StudentPracticeExamTesting', // 模拟考试界面
            component: StudentPracticeExamTesting,
        }, {
            path: 'exam-practice',
            name: 'StudentPracticeExamPractice', // 练习界面
            component: StudentPracticeExamPractice,
        }]
    }, {
        path: 'work-license',
        name: 'StudentWorkLicenseIndex', // 上岗证
        component: StudentWorkLicenseIndex,
        redirect: "/work-license/detalis",
        children: [{
            path: 'detalis',
            name: 'StudentWorkLicenseDetails', // 我的上岗证
            component: StudentWorkLicenseDetails,
        }, {
            path: 'record',
            name: 'StudentWorkLicenseRecord', // 所有上岗证
            component: StudentWorkLicenseRecord,
        }]
    }]
}, {
    path: '/admin',
    name: '登录',
    component: AdminLogin
}, {
    path: '/admin',
    name: 'AdminIndex',
    component: AdminIndex,
    children: [{
        path: 'index',
        name: 'AdminOverviewkIndex', // 后台概览
        component: AdminOverviewkIndex,
    }, {
        path: 'personal-index',
        name: 'AdminPersonalkIndex', // 个人中心
        component: AdminPersonalkIndex,
    }, {
        path: 'question-bank-index',
        name: 'AdminQuestionBankIndex', // 题库首页
        component: AdminQuestionBankIndex,
        // redirect: "/admin/question-bank-index/list",
        children: [{
            path: 'subject',
            name: 'AdminQuestionBankSubject', // 科目管理
            component: AdminQuestionBankSubject,
        }, {
            path: 'list',
            name: 'AdminQuestionBankList', // 题库列表
            component: AdminQuestionBankList,
        }, {
            path: 'edit',
            name: 'AdminQuestionBankEdit', // 编辑题库
            component: AdminQuestionBankEdit,
        }, ]
    }, {
        path: 'exam-index',
        name: 'AdminExamIndex', // 考试管理首页
        component: AdminExamIndex,
        // redirect: "/admin/exam-index/list",
        children: [{
            path: 'list',
            name: 'AdminExamList', // 考试列表
            component: AdminExamList,
        }, {
            path: 'read',
            name: 'AdminExamRead', // 阅卷管理
            component: AdminExamRead,
        }, {
            path: 'read-student',
            name: 'AdminExamReadStudent', // 待阅卷的学生列表
            component: AdminExamReadStudent,
        }, {
            path: 'edit',
            name: 'AdminExamEdit', // 编辑考试
            component: AdminExamEdit,
        }, {
            path: 'row_number',
            name: 'AdminExamRowNumber', // 考场排号
            component: AdminExamRowNumber,
        }]
    }, {
        path: 'paper-index',
        name: 'AdminPaperIndex', // 试卷管理首页
        component: AdminPaperIndex,
        // redirect: "/admin/paper-index/list",
        children: [{
            path: 'list',
            name: 'AdminPaperList', // 试卷列表
            component: AdminPaperList,
        }, {
            path: 'edit',
            name: "AdminPaperEdit", // 试卷编辑
            component: AdminPaperEdit,
        }]
    }, {
        path: 'work-license-index',
        name: 'AdminWorkLicenseIndex', // 上岗证管理首页
        component: AdminWorkLicenseIndex,
        // redirect: "/admin/work-license-index/list",
        children: [{
            path: 'list',
            name: 'AdminWorkLicenseList', // 上岗证考核列表
            component: AdminWorkLicenseList,
        }, {
            path: 'edit',
            name: 'AdminWorkLicenseEdit', // 上岗证考核编辑
            component: AdminWorkLicenseEdit,
        }, {
            path: 'user-list',
            name: "AdminWorkLicenseUserList", // 当前上岗证学员列表
            component: AdminWorkLicenseUserList,
        }, {
            path: 'manage',
            name: "AdminWorkLicenseManage", // 上岗证管理
            component: AdminWorkLicenseManage,
        }, {
            path: 'setting',
            name: "AdminWorkLicenseSetting", // 扣分项设置
            component: AdminWorkLicenseSetting,
        }]
    }, {
        path: 'occupation-index',
        name: 'AdminoccupationIndex', // 职业技能等级管理首页
        component: AdminoccupationIndex,
        // redirect: "/admin/occupation-index/list",
        children: [{
            path: 'list',
            name: 'AdminoccupationList', // 职业技能鉴定任务列表
            component: AdminoccupationList,
        }, {
            path: 'edit',
            name: 'AdminoccupationEdit', // 职业技能鉴定任务编辑
            component: AdminoccupationEdit,
        }, {
            path: 'user-list',
            name: "AdminoccupationUserList", // 当前职业技能鉴定学员考核列表
            component: AdminoccupationUserList,
        }, {
            path: 'setting',
            name: "AdminoccupationSetting", // 扣分项设置
            component: AdminoccupationSetting,
        }]
    }, {
        path: 'system-index',
        name: 'AdminSystemIndex', // 系统设置首页
        component: AdminSystemIndex,
        // redirect: "/admin/system-index/person",
        children: [{
            path: 'department',
            name: 'AdminSystemDepartment', // 部门设置
            component: AdminSystemDepartment,
        }, {
            path: 'person',
            name: 'AdminSystemPerson', // 通讯录
            component: AdminSystemPerson,
        }, {
            path: 'edit-person',
            name: "AdminSystemEditPerson", // 编辑通讯录
            component: AdminSystemEditPerson,
        }, {
            path: 'profession',
            name: 'AdminSystemProfessional', // 专业设置
            component: AdminSystemProfessional,
        }, {
            path: 'tag',
            name: 'AdminSystemTag', // 标签设置
            component: AdminSystemTag,
        }, {
            path: 'manage',
            name: 'AdminSystemDepartment', // 管理员设置
            component: AdminSystemDepartment,
        }, ]
    }]
}, {
    path: '/test',
    name: '测试',
    component: testUeditor
}, ]

const router = new VueRouter({
    routes
})

//导航守卫
router.beforeEach(async(to, from, next) => {
    if (to.path.indexOf("admin") >= 0 && to.name != "登录") {
        // 后台登录要走权限判断
        try {
            let resourceId = ""
            let path = to.path.split("/")
            for (let index = 0; index < path.length; index++) {
                const element = path[index];
                if (element != "") {
                    resourceId = resourceId == "" ? element : resourceId + "_" + element
                }
            }
            let userData = JSON.parse(sessionStorage.getItem("userData"))
            let requestData = {
                userId: userData.userId,
                route: to.path
            }
            let data = await Vue.prototype.$request({
                url: "/authority/getUsersRouteAuthority",
                method: "post",
                data: requestData,
            })
            if (data.authority) {
                // 允许跳转
                next()
            } else {
                Message({
                    message: "您没有权限,请联系管理员!",
                    type: 'error'
                })
            }
        } catch (error) {
            Message({
                message: error,
                type: 'error'
            })
        }
    } else if ((from.path.indexOf('exam/testing') >= 0 || from.path.indexOf('practice/exam-testing') >= 0) &&
        sessionStorage.getItem("testing") == '0') {
        // 正式考试界面/模拟考试界面  跳转做弹窗提示  交卷时将testing置为1  进入考试界面  将testing置为0
        Message({
            message: "请先交卷",
            type: 'warning'
        })
    } else {
        next()
    }
})

Vue.use(VueRouter)

//重复路由
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default router